 <template>
  <div class="batchBox">
    <!--<div class="backBox">-->
      <!--<span v-if="activeIndex === 1" class="goback" @click="goback"><span class="iconfont">&#xe602;</span>返回</span>-->
      <!--<span v-if="activeIndex === 2" class="goback" @click="goTopage"><span class="iconfont">&#xe602;</span>完成</span>-->
    <!--</div>-->
    <div class="batchSteps">
      <div :class="activeIndex >= 0? 'active':''" class="batchStep">
        <div class="stepIndex">1</div>
        <p>数据准备</p>
        <p>设置雇员相关信息模板</p>
      </div>
      <div :class="activeIndex > 0? 'active':''" class="batchStep">
        <div class="stepIndex">2</div>
        <p>表头匹配</p>
        <p>与雇员信息模板进行匹配</p>
      </div>
      <div :class="activeIndex > 1? 'active':''" class="batchStep">
        <div class="stepIndex">3</div>
        <p>查看结果</p>
        <p>上传数据并查看导入结果</p>
      </div>
    </div>
    <step1 v-if="activeIndex === 0" @onupload="addOneStep" @goback="goback"/>
    <step2 v-else-if="activeIndex === 1" :step2-info="this.step2Info" @next="addTwoStep" @goback="goback"/>
    <step3 v-else-if="activeIndex === 2" :step3-info="this.step3Info" @goback="goback" @next="goToTable"/>
  </div>
</template>
<script>
import step1 from './step1'
import step2 from './step2'
import step3 from './step3'
/* import step4 from './step4'*/
export default {
  components: { step1, step2, step3 },
  data() {
    return {
      step2Info: {},// 表头匹配信息
      step3Info:{}, //导入结果
      activeIndex: 0
    }
  },
  methods: {
    // 下一步
    addstep() {
      this.activeIndex = this.activeIndex + 1
    },
    //第一个下一步
    addOneStep(params) {
      this.step2Info=params;
      this.addstep()
    },
    //第二个下一步
    addTwoStep(params) {
      this.step3Info=params;
      this.addstep()
    },
    goback() {
      this.addstep()
    },
    goToTable(){
      this.$router.go(-1)
    },
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .batchBox{
    padding: 20px;
  }
  .batchSteps{
    position: relative;
    margin: 0 auto;
    width: 80%;
    display: flex;
    justify-content: space-between;
  }
  .batchSteps:before{
    content:"";
    position: absolute;
    width: 100%;
    top:25px;
    left:0;
    height:1px;
    background-color: #eeeeee;
    z-index:0;
  }
  .batchStep{
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding:10px;
  }
  .stepIndex{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border:1px solid #ccc;
    box-sizing: border-box;
    font-size: 16px;
    color:#ccc;
  }
  .active .stepIndex{
    background-color: rgba(38, 156, 255, 1);
    border:2px solid rgba(38, 156, 255, 1);
    color:#ffffff;
  }
  .batchStep p{
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    color:#999999;
  }
  .batchStep p+p{
    color:#cccccc;
    margin-top: 0;
    font-size: 12px;
  }
  .active.batchStep p{
    color:#269cff;
  }
</style>
